import { useContext } from "react";
import { PricingContext } from "./context";

const usePricing = () => useContext(PricingContext);
export default usePricing;
